import requestAccessImage from 'assets/images/RequestAccess_1.gif';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.less';
import { Modal } from 'antd';
export const RequestAccessModal = () => {
  const {
    t
  } = useTranslation();
  return <Modal className="newRequestAccessModal" style={{
    top: '3rem'
  }} open footer={null} width={920} destroyOnClose={true} closable={false} data-sentry-element="Modal" data-sentry-component="RequestAccessModal" data-sentry-source-file="index.tsx">
      <img data-testid="newRequestAccessModal" className="not-request-access-gif" src={requestAccessImage} alt="Request" />
      <div className="text-content-container">
        <p className="title">{t('You don’t have access to Cropwise Dev Console')}</p>
        <br />
        <p className="sub-title-text">{t('Dev Console is the Cropwise asset responsible for')}</p>
        <p className="sub-title-text">{t('managing users, along with their APPs, plans, contracts,')}</p>
        <p className="sub-title-text">{t('and permissions within the ecosystem.')}</p>
        <br />
        <p className="sub-title-text">{t('If you need access, please contact Syngenta Digital Support.')}</p>
      </div>
    </Modal>;
};
const RequestAccessAddon: React.FC<{}> = (props: any) => {
  return <RequestAccessModal {...props} data-sentry-element="RequestAccessModal" data-sentry-component="RequestAccessAddon" data-sentry-source-file="index.tsx" />;
};
export default RequestAccessAddon;